import { ComboBox } from "@carbon/react";
import { ComboBoxProps } from "@carbon/react/lib/components/ComboBox/ComboBox";

export type SinglePickerProps<TItem> = {
  id: string;
  selectedItem?: TItem | null;
  onChange: (item: TItem | null | undefined) => void;
  invalid?: boolean;
  disabled?: boolean;
  placeholder?: string;
} & Pick<
  ComboBoxProps<TItem>,
  "items" | "helperText" | "titleText" | "invalidText" | "itemToString" | "direction" | "autoAlign"
>;

export function SinglePicker<TItem>({
  id,
  items,
  itemToString,
  titleText,
  helperText,
  invalid,
  invalidText,
  disabled,
  placeholder,
  direction,
  autoAlign,
  selectedItem,
  onChange,
}: SinglePickerProps<TItem>) {
  const filterItems = (
    ...args: Parameters<NonNullable<ComboBoxProps<TItem>["shouldFilterItem"]>>
  ) => {
    const [{ itemToString, inputValue, item }] = args;
    const itemStr = itemToString ? itemToString?.(item) : item?.toString() ?? "";
    return itemStr.toLowerCase().includes(inputValue?.toLowerCase() ?? "");
  };

  return (
    <ComboBox
      autoAlign={autoAlign}
      id={id}
      itemToString={itemToString}
      items={items}
      titleText={titleText}
      invalid={invalid}
      invalidText={invalidText}
      helperText={helperText}
      shouldFilterItem={filterItems}
      disabled={disabled}
      direction={direction}
      placeholder={placeholder}
      selectedItem={selectedItem}
      onChange={(data) => onChange(data.selectedItem)}
    />
  );
}

export default SinglePicker;
